import React from "react";

import GovernanceExceptionQueue from "@/components/governance/GovernanceExceptionQueue";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const ClientDashboard: React.FC = () => {
  return (
    <main className="space-y-6">
      <section>
        <h1 className="text-2xl font-semibold text-slate-950">Client Workspace</h1>
        <p className="mt-1 text-sm text-slate-600">
          Governance oversight console for tenant-scoped journey, audit, exception,
          and reporting visibility.
        </p>
      </section>

      <div className="grid gap-4 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Oversight Boundary</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm text-slate-700">
            <div className="flex flex-wrap gap-2">
              <Badge variant="secondary">Read-only by default</Badge>
              <Badge variant="secondary">Tenant scoped</Badge>
              <Badge variant="secondary">Backend authority</Badge>
            </div>
            <p>
              Client users can inspect governance signals and scoped reports.
              Operational assignment, queue processing, bulk actions, and direct
              workflow mutation stay outside the client surface.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Veto Rule</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-slate-700">
            Client comments are only allowed as a mandatory veto reason during
            an explicit backend workflow veto. This dashboard does not expose
            arbitrary comment threads or operational action buttons.
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">PII Visibility</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-slate-700">
            Applicant data is governed by policy tiers: minimal, masked, or full.
            The default oversight projection is masked unless a tenant policy
            explicitly permits broader visibility.
          </CardContent>
        </Card>
      </div>

      <GovernanceExceptionQueue
        title="Client Governance Signals"
        roleScope="client"
        emptyCopy="No client-visible governance signals."
      />
    </main>
  );
};

export default ClientDashboard;
